import { supabase } from '@/integrations/supabase/client';

interface AlertThresholds {
  criticalErrorsInHour: number;
  highErrorsInHour: number;
  totalErrorsInHour: number;
}

const THRESHOLDS: AlertThresholds = {
  criticalErrorsInHour: 1, // Alerta imediato para erros críticos
  highErrorsInHour: 5,     // 5+ erros high em 1 hora
  totalErrorsInHour: 20,   // 20+ erros totais em 1 hora
};

export const checkAndSendCriticalAlert = async (
  errorType: string,
  errorMessage: string,
  severity: 'low' | 'medium' | 'high' | 'critical',
  component?: string
) => {
  try {
    // Se for erro crítico, enviar alerta imediatamente
    if (severity === 'critical') {
      await sendAlert({
        errorType,
        errorMessage,
        severity,
        component,
        errorCount: 1,
        timestamp: new Date().toISOString(),
      });
      return;
    }

    // Para outros erros, verificar thresholds
    const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000).toISOString();

    const { data: recentErrors } = await supabase
      .from('error_logs' as any)
      .select('severity')
      .gte('created_at', oneHourAgo);

    if (!recentErrors) return;

    const errorCounts = recentErrors.reduce(
      (acc: any, log: any) => {
        acc.total++;
        acc[log.severity]++;
        return acc;
      },
      { total: 0, critical: 0, high: 0, medium: 0, low: 0 }
    );

    // Verificar se algum threshold foi atingido
    let shouldAlert = false;
    let alertReason = '';

    if (errorCounts.high >= THRESHOLDS.highErrorsInHour) {
      shouldAlert = true;
      alertReason = `${errorCounts.high} erros de alta severidade na última hora`;
    } else if (errorCounts.total >= THRESHOLDS.totalErrorsInHour) {
      shouldAlert = true;
      alertReason = `${errorCounts.total} erros totais na última hora`;
    }

    if (shouldAlert) {
      await sendAlert({
        errorType: 'multiple_errors',
        errorMessage: alertReason,
        severity: 'high',
        component: 'system_monitoring',
        errorCount: errorCounts.total,
        timestamp: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error('Error in critical alert system:', error);
  }
};

const sendAlert = async (alertData: {
  errorType: string;
  errorMessage: string;
  severity: string;
  component?: string;
  errorCount: number;
  timestamp: string;
}) => {
  try {
    const { error } = await supabase.functions.invoke('send-critical-alert', {
      body: alertData,
    });

    if (error) {
      console.error('Failed to send critical alert:', error);
    } else {
      console.log('Critical alert sent successfully');
    }
  } catch (error) {
    console.error('Error invoking alert function:', error);
  }
};
